// Toutes les queries dont un titre dictionnaire (marque, taille, couleur,
// catégorie, nœud catalogue, brandTitle/conditionTitle…) est résolu côté
// serveur dans la langue du compte — cf changelog §2. Invalidation par clé
// RACINE (préfixe) : couvre toutes les variables (analysisId, veilleId…) en
// cache sans avoir à les énumérer. Les queries Vestiaire en font partie :
// sans elles, l'arbre des catégories VC (gardé en cache à vie,
// `staleTime: Infinity`) restait dans la langue de son premier chargement.
export const LOCALIZED_TITLE_QUERY_KEYS: string[][] = [
  ['GetAnalysisSegmentFacets'],
  ['GetAnalysisNiches'],
  ['GetAnalysisDashboard'],
  ['GetAnalysisBrandDistribution'],
  ['GetAnalysisCategoriesLevelsDistribution'],
  ['GetVintedCatalogTree'],
  ['GetVintedCatalogFilters'],
  ['SearchVintedCatalogFilterOptions'],
  ['ParseVintedCatalogUrl'],
  ['GetProductFeed'],
  ['GetProductById'],
  ['GetVeilleFeed'],
  ['GetVestiaireCatalogTree'],
  ['GetVestiaireFilterOptions'],
  ['GetVestiaireCountries'],
];
